import { useForm } from '@inertiajs/vue3';

export default {
  data() {
    return {
      monoCheckoutForm: useForm()
    }
  },
  methods: {
    monoCheckout() {
      this.monoCheckoutForm.post(this.route('orders.store_mono'))
    }
  }
}
